import React, { useEffect, useState } from "react";
import {
  Badge,
  IconButton,
  MenuItem,
  Menu,
  Typography,
  Link,
  Box,
} from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ListItemIcon from "@mui/material/ListItemIcon";
import Tooltip from "@mui/material/Tooltip";
import Swal from "sweetalert2";
import axios from "axios";
import storage from "@/utils/storage";
import { deleteAllNotification } from "./api/deleteAllNotification";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  disableRipple: {
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
}));

const NotificationPopup = () => {
  const classes = useStyles();
  const [notificationCount, setNotificationCount] = useState(0);
  // const [isPopupOpen, setPopupOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [menuItems, setMenuItems] = useState({});
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  console.log(menuItems[0]?.data, "menuItems");
  const open = Boolean(anchorEl);
  
  const handleClick = async (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setPage(1); // reset to page 1
    fetchNotifications(1, true);
  };
  useEffect(() => {
    fetchNotifications(page);
  }, []);
  const fetchNotifications = async (
    pageNumber: number,
    reset: boolean = false
  ) => {
    const token = storage.getToken();
    try {
      const res = await axios.get(
        `${process.env.API_URL_PREFIX}/api/v1/user/notification?page=${pageNumber}&limit=10`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      );

      const fetchedData = res.data.data;
      const count = fetchedData?.[0]?.unreadCount ?? 0;

      console.log(count, "count");
      if (reset) {
        setMenuItems(fetchedData);
      } else {
        setMenuItems((prev) => ({
          ...prev,
          [0]: {
            ...prev[0],
            data: [
              ...(prev[0]?.data || []),
              ...(Array.isArray(fetchedData[0]?.data)
                ? fetchedData[0].data
                : []),
            ],
          },
        }));
      }

      setHasMore(fetchedData[0]?.data?.length > 0);
      setNotificationCount(count);
    } catch (err) {
      console.log(err);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const readNotificationApi = async (id, linkTo) => {
    let token = storage.getToken();
    await axios
      .put(
        `${process.env.API_URL_PREFIX}/api/v1/user/readNotification/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        setNotificationCount((prev) => 0);
        window.location.assign(linkTo);
      })

      .catch((err) => {
        console.log(err);
      });
  };

  const handleClearAll = async () => {
    try {
      const result = await Swal.fire({
        title: "Notifications",
        text: "Are you sure you want to delete all notifications?",
        icon: "warning",
        background: "black",
        showCancelButton: true,
        color: "white",
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
      });

      if (result.isConfirmed) {
        await deleteAllNotification();
        setMenuItems([]);
        setNotificationCount(0);

        Swal.fire({
          background: "black",
          color: "#ffff",
          icon: "success",
          title: "Success!",
          text: "All notifications deleted!",
        });
      }
    } catch (error) {
      console.error("Error deleting notifications:", error);
      Swal.fire({
        background: "black",
        color: "#ffff",
        icon: "error",
        title: "Opps!",
        text: "Failed to delete notifications.",
      });
    }
  };

  return (
    <div>
      <Tooltip title="Notifications">
        <Badge
          badgeContent={notificationCount > 0 ? notificationCount : 0}
          color="secondary"
          sx={{
            "& .MuiBadge-badge": {
              top: "7px",
              right: "9px",
              fontSize: "0.7035714285714286rem",
              minWidth: "5px",
              backgroundColor: "red",
            },
          }}
            onClick={handleClick}
        >
          <IconButton
            color="inherit"
            disableRipple
            className={classes.disableRipple}
            onClick={handleClick}
            size="small"
            aria-controls={open ? "account-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
          >
            <NotificationsIcon sx={{ color: "#fff" }} />
          </IconButton>
        </Badge>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        PaperProps={{
          elevation: 2,
          sx: {
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.2))",
            mt: 1.5,
            width: 300,
            maxHeight: 400,
            overflowY: "auto",
            borderRadius: "10px",
            bgcolor: "#1e1e2f",
            color: "white",
            px: 1,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 18,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
            "&::-webkit-scrollbar": {
              width: "5px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#555",
              borderRadius: "100px",
            },
          },
          onScroll: (e: React.UIEvent<HTMLDivElement>) => {
            const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
            const isBottom = scrollTop + clientHeight >= scrollHeight - 5; // 5px threshold
            if (isBottom && hasMore) {
              const nextPage = page + 1;
              setPage(nextPage);
              fetchNotifications(nextPage);
            }
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {menuItems[0]?.data?.length > 0 ? (
          <MenuItem
            onClick={handleClearAll}
            sx={{
              justifyContent: "center",
              fontWeight: "bold",
              color: "#FFBC00",
            }}
          >
            Clear All
          </MenuItem>
        ) : (
          <MenuItem
            sx={{
              justifyContent: "center",
              fontWeight: "bold",
              color: "#FFBC00",
            }}
          >
            No Notifications Found
          </MenuItem>
        )}
        {menuItems[0]?.data?.length > 0 &&
          menuItems[0]?.data.map((value: any, index: number) => {
            let linkTo = "/app/upComingLotteries";
            if (value?.subject === "Try your luck") {
              linkTo = "/app/upComingLotteries";
            } else if (value?.subject === "Payment Confirmation") {
              linkTo = "/app/wallet/MyLottery";
            } else if (value?.subject === "Friend Referral") {
              linkTo = "/app/wallet/MyLottery";
            }else if (value?.subject === "Ticket numbers are Allocated") {
              linkTo = "/app/wallet/MyLottery";
            }else if (value?.subject === "Played lottery draw") {
              linkTo = "/app/wallet/MyLottery";
            }
            else if (value?.link) {
              linkTo = value.link;
            }
            return (
              <MenuItem
                key={index}
                onClick={handleClose}
                sx={{ alignItems: "flex-start", whiteSpace: "normal", py: 1.2 }}
              >
                <ListItemIcon>
                  <NotificationsIcon
                    fontSize="small"
                    sx={{ color: value.readNotify ? "white" : "#FFBC00" }}
                  />
                </ListItemIcon>
                <Link
                  href={linkTo}
                  underline="none"
                  color="inherit"
                  onClick={(e) => {
                    e.preventDefault();
                    readNotificationApi(value?._id, linkTo);
                  }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      sx={{
                        fontSize: 14,
                        fontWeight: 600,
                        color: value.readNotify ? "white" : "#FFBC00",
                      }}
                    >
                      {value?.subject}
                    </Typography>
                    <Typography sx={{ fontSize: 12, color: "#ccc" }}>
                      {new Date(value?.createdAt).toLocaleDateString()}{" "}
                      {new Date(value?.createdAt).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </Typography>

                    <Typography
                      sx={{ fontSize: 13, mt: 0.5, color: "#FFFFFFCC" }}
                    >
                      {value?.description}
                    </Typography>
                  </Box>
                </Link>
                
              </MenuItem>
            );
          })}
      </Menu>
    </div>
  );
};

export default NotificationPopup;
